import EventEmitter, {
  API_TIMEOUT,
} from '../../component/helpers/EventEmitter';
import { val } from '../../component/helpers/Text';
import { getLanguage } from './../../component/helpers/Language';
import connector from './../Connector';
import { func } from 'prop-types';

export default class ProxyBase {
  baseServiceUrl = '';

  constructor(url) {
    this.baseServiceUrl = url;
  }

  //return a promise
  get(
    methodName,
    data = {},
    source,
    type,
    isParseParams = true,
    useAuth = true,
  ) {
    let url = this.baseServiceUrl + methodName;
    let params = data;
    if (isParseParams) {
      params = new URLSearchParams();
      params.append('language', getLanguage());
      if (typeof data === 'object' && data) {
        Object.keys(data).forEach(key => {
          if (Array.isArray(data[key])) {
            data[key].forEach(value => {
              params.append(
                key,
                value === null || value === undefined ? '' : value,
              );
            });

            return;
          }

          params.append(
            key,
            data[key] === null || data[key] === undefined ? '' : data[key],
          );
        });
      }
    }

    url += '?' + params.toString();

    return new Promise(function(resolve, reject) {
      connector.get(url, function(data) {
        resolve(data);
      });
    });
  }

  post(path, data, config = {}, type) {
    var url = this.baseServiceUrl + path;
    return new Promise(function(resolve, reject) {
      connector.post(url, data, type, function(data) {
        resolve(data);
      });
    });
  }
}
